import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'ANTEPRIMA',
        description:
            "Qui vedi il testo integrale dell'esercizio e la soluzione se presente. Trovi il pulsante per modificarlo o per duplicarlo oppure premi 'Elimina' per cancellarlo dall'archivio.",
        isActive: true,
        name: 'Preview',
        tutorialName: 'archivio_anteprima-esercizio-docente'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'LEFT',
        yPlacement: 'TOP',
        xOffset: 20,
        yOffset: 20
    },
    pages: ['#/myLibrary/exercises', '#/myLibrary/exercises/']
};
